import { BadgeVariants } from '@carboledger/ui';
import { OUTGOING_SHIPMENT_STATUS_TONE } from '@/config/statusTones';
import { defaultUnitType } from '@/lib/mappers/quantities';

// The header's discrepancy modal field sections.
export const buildOutgoingShipmentDiscrepancySections = (t, shipment) => {
  if (!shipment) return [];
  const quantities = shipment.byUnit?.[defaultUnitType(shipment.byUnit)];
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: shipment.materialName },
        {
          label: t('FIELD_STATUS'),
          value: shipment.statusLabel,
          type: 'status',
          tone: OUTGOING_SHIPMENT_STATUS_TONE[shipment.statusCode] ?? BadgeVariants.default,
        },
        { label: t('FIELD_SOLD_TO'), value: shipment.soldTo },
        { label: t('FIELD_SHIPPING_TO'), value: shipment.shippingTo },
        { label: t('FIELD_DATE_OF_DISPATCH'), value: shipment.dateOfDispatch },
      ],
    },
    {
      title: t('SECTION_QUANTITY'),
      fields: [
        { label: t('FIELD_SHIPMENT_QUANTITY'), value: quantities?.shipmentQuantity },
        { label: t('FIELD_ALLOCATED_QUANTITY'), value: quantities?.allocatedQuantity },
        {
          label: t('FIELD_REMAINING_TO_ALLOCATE_QUANTITY'),
          value: quantities?.remainingToAllocateQuantity,
        },
      ],
    },
  ];
};

// The LIST row's discrepancy modal — a row carries no status code, so it shows none.
export const buildOutgoingShipmentRowDiscrepancySections = (t, row, unitType) => {
  if (!row) return [];
  const unit = row.byUnit?.[unitType ?? row.unitType] ?? {};
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: row.materialName },
        { label: t('FIELD_FACILITY_NAME'), value: row.facilityName },
        { label: t('FIELD_TERMINAL'), value: row.terminal },
        { label: t('FIELD_SOLD_TO'), value: row.soldTo },
        { label: t('FIELD_SHIPPING_TO'), value: row.shippingTo },
        { label: t('FIELD_DATE_OF_DISPATCH'), value: row.dateOfDispatch },
      ],
    },
    {
      title: t('SECTION_QUANTITY'),
      fields: [
        { label: t('FIELD_SHIPMENT_QUANTITY'), value: unit.shipmentQuantity },
        { label: t('FIELD_ALLOCATED_QUANTITY'), value: unit.allocatedQuantity },
        {
          label: t('FIELD_REMAINING_TO_ALLOCATE_QUANTITY'),
          value: unit.remainingToAllocateQuantity,
        },
      ],
    },
  ];
};
